import { useState as a, useRef as l, useEffect as f } from "react";
const g = 5e3, I = (o, e, r = 10) => {
  const [u, n] = a(!1), s = l(), t = l(r), i = () => {
    n(!0), s.current = setInterval(() => {
      o(), t.current--;
    }, g);
  };
  f(() => {
    t.current || (c(), e && e());
  }, [t.current]);
  const c = () => {
    n(!1), t.current = r, clearInterval(s.current);
  };
  return { isPolling: u, startPolling: i, stopPolling: c };
};
export {
  I as default
};
